import axios from "axios";

import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";
import { POST } from "../adapters/xhr";

export default function (licenceApplicationId) {
    return async (dispatch, getState) => {
        dispatch(CreateDataRetrievalBegunAction());
        const { currentVessel } = getState();

        const newVessel = {
            id: Number(currentVessel.id) || 0,
            name: currentVessel.name,
            licenceApplicationId: Number(licenceApplicationId) || 0,
            vesselTypeId: currentVessel.vesselTypeId && Number(currentVessel.vesselTypeId),
            vesselSubTypeId: currentVessel.vesselSubTypeId && Number(currentVessel.vesselSubTypeId),
            isOtherVesselType: currentVessel.isOtherVesselType || false,
            otherVesselTypeDescription: currentVessel.otherVesselTypeDescription || "",
            hullColorId: currentVessel.hullColorId && Number(currentVessel.hullColorId),
            seaAreaOfOperationId: currentVessel.seaAreaOfOperationId && Number(currentVessel.seaAreaOfOperationId),
            maxCapacityOfPersonsOnBoard: Number(currentVessel.maxCapacityOfPersonsOnBoard),
            vesselLength: Number(currentVessel.vesselLength),
            grossTonnage: Number(currentVessel.grossTonnage),
            description: currentVessel.description,
            homePort: currentVessel.homePort,
            registerationNumber: currentVessel.registerationNumber,
            fishingVesselPrefixTypeId: Number(currentVessel.fishingVesselPrefixTypeId) || null,
            fvVesselIdentificationNumber: currentVessel.fvVesselIdentificationNumber,
            fishingVesselPostfixTypeId: Number(currentVessel.fishingVesselPostfixTypeId) || null,
            imoNumber: currentVessel.imoNumber,
            numberOfLifeBoats: currentVessel.numberOfLifeBoats && Number(currentVessel.numberOfLifeBoats),
            accountingAuthorityIdentificationCodeId: Number(currentVessel.accountingAuthorityIdentificationCodeId) || null,
            callSignNumber: currentVessel.callSignNumber,
            mmsiNumber: currentVessel.mmsiNumber
        };

        try {
            const response = await axios({
                method: "put",
                url: "api/Vessel/UpdateIssuedVessel",
                data: newVessel,
                withCredentials: true
            });

            if (response.data.licenceAmended) {
                dispatch({
                    type: "LICENCE_AMENDMENT",
                    data: true
                });
                dispatch({
                    type: "LICENCE_APPLICATIONTYPEID_UPDATED",
                    data: 3
                });
                
                // Create payment record synchronously for amendments during reviews
                // Get amendment price from pricing configuration...
                //Please work....
                const state = getState();
                const amendmentPaymentDetail = state.availablePricings.find(p => p.id === 3); // AmendLicence = 3
                const amendmentPaymentAmount = Number(amendmentPaymentDetail?.price) || 0;
                
                if (amendmentPaymentAmount > 0) {
                    const paymentModel = {
                        id: 0,
                        transId: null,
                        licenceApplicationId: Number(licenceApplicationId) || 0,
                        paymentAmount: amendmentPaymentAmount,
                        created: new Date(),
                        createdBy: ""
                    };
                    
                    try {
                        const paymentResponse = await POST("api/LicenceApplication/NewLicencePayment", paymentModel);
                        if (paymentResponse.status === 200) {
                            dispatch({
                                type: "LICENCE_PAYMENT_RETRIEVED",
                                data: paymentResponse.data.licencePayment
                            });
                        } else {
                            console.error(`Payment creation failed with status ${paymentResponse.status}`);
                        }
                    } catch (paymentError) {
                        console.error('Payment creation failed:', paymentError);
                        // Payment creation failed, but continue with the vessel update
                    }
                } else {
                    console.warn('No amendment pricing found in configuration');
                }
            }
            dispatch(CreateDataRetrievalEndedAction());
        } catch (error) {
            dispatch(CreateDataRetrievalEndedAction());
            throw error;
        }
    };
}
